@let orders = (customer$ | async)?.orders;

<div class="toolbar-break">
</div>
<div class="container">
  <div class="hero-title my-5">
    <h1>My Orders</h1>
    @if ((customer$ | async)?.firstName) {
      <div class="mt-lg-3">
        <span>Welcome back, {{(customer$ | async)!.firstName | titlecase}}</span>
      </div>
    }
    @if ((spinner$ | async)?.show) {
      <div class="spinner">
        <ngx-spinner bdColor="rgba(255, 255, 255, 0)" size="medium" color="#000" type="ball-scale-ripple-multiple"
          [fullScreen]="false">
          <p style="color: black"> Loading... </p>
        </ngx-spinner>
      </div>
    }
    @if ((!orders) && !(spinner$ | async)?.show) {
      <p class="mt-5">Login or register to view your orders.</p>
      <div class="d-flex justify-content-between login-box pt-3">
        <button aria-label="Sign In" class="primary" (click)="openLogin()">Sign in</button>
        <button aria-label="Register" class="primary" (click)="openRegister()">Register</button>
      </div>
    }
    @if (orders) {
      @if (orders!.length < 1) {
        <p class="my-4">Looks like you have yet to place an order with us.</p>
        <h3 class="mb-3">How about we change that?</h3>
        <app-search class="w-100"></app-search>
        <a class="link d-flex align-items-center h-100 mb-5" routerLink="/">
          <mat-icon class="me-3">west</mat-icon>
          <span>Go back to MyPoolHut.com</span>
        </a>
      }
    }
    <!-- Desktop -->
    <div class="d-none d-lg-block">
      @if (orders) {
        @if (orders!.length > 0) {
          <div class="orders-box mt-5">
            <div class="row p-3 mx-2 fw-bold">
              <div class="col-2">
                <span>Order</span>
              </div>
              <div class="col-3">
                <span>Date</span>
              </div>
              <div class="col-2">
                <span>Payment Status</span>
              </div>
              <div class="col-2">
                <span>Fullfillment Status</span>
              </div>
              <div class="col-3 text-end">
                <span>Total</span>
              </div>
            </div>
            <div class="order-border">
            </div>
            @for (order of orders; track order) {
              <div class="row p-3 order-row mx-2" routerLink="/orders/{{order.number}}">
                <div class="col-2">
                  <a class="link-text">#{{order.number}}</a>
                </div>
                <div class="col-3">
                  <span>{{order.processedAt | date: 'longDate'}}</span>
                </div>
                <div class="col-2">
                  <span>{{order.financialStatus?.label}}</span>
                </div>
                <div class="col-2">
                  <span>{{order.fulfillmentStatus.label}}</span>
                </div>
                <div class="col-3 text-end">
                  <span>{{order.subtotalPrice | currency: 'USD'}}</span>
                </div>
              </div>
            }
          </div>
        }
      }
    </div>
    <!-- Mobile -->
    <div class="d-block d-lg-none">
      @for (order of orders; track order) {
        <div class="order-border mt-3 pt-2">
          <div class="d-flex justify-content-between">
            <span>Order</span>
            <span class="fw-bold">#{{order.number}}</span>
          </div>
          <div class="d-flex justify-content-between">
            <span>Date</span>
            <span>{{order.processedAt | date: 'longDate'}}</span>
          </div>
          <div class="d-flex justify-content-between">
            <span>Payment Status</span>
            <span>{{order.financialStatus?.label}}</span>
          </div>
          <div class="d-flex justify-content-between">
            <span>Fulfillment Status</span>
            <span>{{order.fulfillmentStatus.label}}</span>
          </div>
          <div class="d-flex justify-content-between">
            <span>Total</span>
            <span>{{order.subtotalPrice | currency: 'USD'}}</span>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <button routerLink="/orders/{{order.number}}" class="primary small-btn mt-2">View Order</button>
        </div>
      }
    </div>
    <div class="my-5">
      <span>Need help with an order or subscription? Email us at <a class="link-text" href="mailto:support@mypoolhut.com">support&#64;mypoolhut.com</a> or submit a message below.</span>
    </div>
  </div>
</div>
